import { APIScope, LocationVarKey } from "@swivl-mono/types";
import { useHasPermission } from "../../Helpers/Permissions/useHasPermission";

interface ShowIfProps {
    scope?: APIScope;
    inGroupId?: number, 
    inLocationId?: number
    children: React.ReactNode;
}

export function ShowIf(props: ShowIfProps) {
    

    const hasPermissions = useHasPermission(props.scope, props.inGroupId, props.inLocationId);
    
    if (hasPermissions) {
        return props.children;
    }
    return null;
}
